<template>
  <tbody class="tbody-res ">
  <tr>
    <td>{{ item.lata }}</td>
    <td>{{ item.rate_center }}</td>
    <td>{{ item.state }}</td>
    <td>{{ item.telephone_number }}</td>
    <td>{{item.tier }}</td>
    <td>
      <b-form-checkbox
        id="checkbox-3"
        v-model="item.add_to"
        :checked="item.add_to"
        name="local"
      />
    </td>
  </tr>
  </tbody>
</template>

<script>
export default {
  name: "ItemSearchResult",
  props: {
    initialItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      item: this.initialItem,
    }
  },
}
</script>

<style scoped lang="scss">

tr {
  border-spacing: 10px 0;
  td {
    padding-left: 10px;
    padding-bottom: 15px;
    padding-top: 10px;
  }
}
</style>
